import React from "react";
import "./ContentRenderer.css";

const RenderElement = ({ element }) => {
  if (element.tag_type === "p") {
    return <p className="content-paragraph">{element.text}</p>;
  } else if (element.tag_type === "h1") {
    return <h1 className="step-title">{element.text}</h1>;
  } else if (element.tag_type === "h2") {
    return <h2 className="content-heading">{element.text}</h2>;
  } else if (element.tag_type === "h3") {
    return <h3 className="subHeading">{element.text}</h3>;
  } else if (element.tag_type === "h4") {
    return <h4 className="content-inner-heading">{element.text}</h4>;
  } else if (element.tag_type === "img") {
    return (
      <img
        src={element.src}
        alt={element.text || "image"}
        className="content-img"
      />
    );
  } else if (element.tag_type === "div") {
    return (
      <div className="content-div">
        {element.children &&
          element.children.map((child, childIdx) => (
            <ContentRenderer key={childIdx} content={[{ content: [child] }]} />
          ))}
      </div>
    );
  } else if (element.tag_type === "ul") {
    return (
      <ul className="content-list ulList">
        {element.items &&
          element.items.map((item, itemIdx) => (
            <li key={itemIdx}>
              {item.textParts ? (
                item.textParts.map((part, partIdx) => {
                  if (part.link) {
                    return (
                      <a
                        key={partIdx}
                        href={part.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {part.text}
                      </a>
                    );
                  } else if (part.tag_type === "span") {
                    return (
                      <span key={partIdx} className={part.class}>
                        {part.text}
                      </span>
                    );
                  } else {
                    return <span key={partIdx}>{part.text}</span>;
                  }
                })
              ) : (
                <span>{item.text}</span>
              )}
            </li>
          ))}
      </ul>
    );
  } else if (element.tag_type === "ol") {
    return (
      <ol className="content-list ordered">
        {element.items &&
          element.items.map((item, itemIdx) => (
            <li key={itemIdx}>
              {item.text}
              {item.sub_items && (
                <ol>
                  {item.sub_items.map((subItem, subItemIdx) => (
                    <li key={subItemIdx}>
                      {subItem.text}
                      {subItem.extra_text && (
                        <span> - {subItem.extra_text}</span>
                      )}
                      {subItem.code && (
                        <pre className="script_code">
                          <code>{subItem.code}</code>
                        </pre>
                      )}
                    </li>
                  ))}
                </ol>
              )}
              {item.img && (
                <img src={item.img} alt="Inline image" className="content-img" />
              )}
            </li>
          ))}
      </ol>
    );
  } else {
    return null;
  }
};

const ContentRenderer = ({ content }) => {
  if (!content) return null;

  return content.map((item, idx) => (
    item.content.map((element, elementIdx) => (
      <RenderElement key={elementIdx} element={element} />
    ))
  ));
};

export default ContentRenderer;
